import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import InputString from 'components/InputString'
import InputNumber from 'components/InputNumber'
import { CardBody, Button } from '@pancakeswap-libs/uikit'
import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { BigNumber } from '@ethersproject/bignumber'
// import { useTokenContract } from '../../hooks/useContract'
// import { AutoColumn } from 'components/Column'
// import { Contract } from 'ethers'

import { Contract } from 'ethers'
import AppBody from '../AppBody'
import { Wrapper, InputTitle, InputBox, Title } from './styleds'
import { useActiveWeb3React } from '../../hooks'
import { TOKEN_FACTORY } from '../../constants'
import TOKEN_FACTORY_ABI from '../../constants/abis/tokenFactory.json'



export default function CreateToken() {
    const { account, chainId, library } = useActiveWeb3React()
    const { t } = useTranslation()

    const [name, setName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [decimals, setDecimals] = useState('');
    const [amount, setAmount] = useState(''); 
    const [loading, setLoading] = useState(false);
   
    const { toastSuccess, toastError } = useToast()
 
    const handleInputName = async value => {
      setName(value)
    };
    const handleInputSymbol = async value => {
      setSymbol(value)
    };
    const handleInputDecimals = async value => {
      setDecimals(value)
    };
    const handleInputAmount = async value => {
      setAmount(value)
    };

     const handleRegister = async () => {
      
      if (!chainId || !library || !account) return
      if(Number(decimals) < 9 || Number(decimals) > 18 ) {
        toastError(t('Decimals setting error'))
        return 
      }
       setLoading(true)
       try {
         const contract = new Contract(TOKEN_FACTORY, TOKEN_FACTORY_ABI,getSigner(library, account))
         const tokenAmount = BigNumber.from(amount).mul(`${10 ** Number(decimals)}`).toString()
         const tx = await contract.createToken(name, symbol, decimals, tokenAmount)
         // eslint-disable-next-line no-console
        //  console.log(tx, 'tx----')
        //  addTransaction(tx, {
        //   summary: `Register token ${tokenAddress}`
        // })
        await tx.wait();
        toastSuccess(t('Token created successfully'))
         setLoading(false)
       } catch {
        toastError(t('Token created failed'))
         setLoading(false)
       }
     }

    return (
      <Container>
        
        <RowBetween marginBottom='30px' maxWidth="436px">
          <span>  </span>
          <HistoryLink style={{ color:'#29CAD5' }}  to="/tokens">{ t('Currency record') }</HistoryLink>
        </RowBetween>
      <AppBody>
        <Wrapper>
        <Title>
            { t('One-click create your tokens') }
          </Title>
          <CardBody>
             <InputBox>
               <InputTitle>{ t('TOKEN Name') }</InputTitle>
               <InputString value={ name } placeholder={ t('Please enter name') } onUserInput={ handleInputName }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('TOKEN Symbol') }</InputTitle>
               <InputString value={ symbol } placeholder={ t('Please enter symbol') } onUserInput={ handleInputSymbol }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('TOKEN Decimals') }</InputTitle>
               <InputNumber  value={ decimals } placeholder={ t('Format 9-18 digits')} onUserInput={ handleInputDecimals }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('Issue Number') }</InputTitle>
               <InputNumber  value={ amount } placeholder={ t('Please enter the issue quantity') } onUserInput={ handleInputAmount }/>
             </InputBox>
            
             

             {!name || !symbol || !decimals || !amount ? (
                <Button disabled width="100%">{ t('Not all entered') }</Button>
              ) 
              : (<Button width="100%" disabled={ loading } onClick={ handleRegister }>{ loading ? `${t('Create')}...` : t('Create')}</Button>)
            }
            
          </CardBody>
        </Wrapper>
      </AppBody>
    </Container>
    )
  }